import { Box, Paper, Stack, Typography } from '@mui/material';
import { ChoiceControl, HelpPopover } from '../../../design-system';

export function PolicySwitch({
  title,
  description,
  checked,
  disabled,
  onChange,
}: {
  title: string;
  description: string;
  checked: boolean;
  disabled: boolean;
  onChange: (checked: boolean) => void;
}) {
  return <Paper variant="outlined" sx={{ flex: 1, p: 1.5 }}><Stack direction="row" sx={{ alignItems: 'start' }}><Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}><Typography variant="body2" sx={{ fontWeight: 700 }}>{title}</Typography><HelpPopover title={title}>{description}</HelpPopover></Box><ChoiceControl kind="switch" checked={checked} disabled={disabled} ariaLabel={title} onCheckedChange={onChange} /></Stack></Paper>;
}
